var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[(_vm.isNavOpen)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.toggleNav}}):_vm._e(),_c('transition',{attrs:{"name":"slide"}},[(_vm.isNavOpen)?_c('div',{staticClass:"sidebar-panel pt-4"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }